import React from 'react';

export default class Tabs extends React.Component {
    constructor(props) {
        super(props);
    }
    handleClick(func,i,parms) {
        return func(i,...parms);
    }
    render() {
        const self=this;
        const tabpercent = 100/this.props.labels.length;
        const onTabClick = this.props.onTabClick;
        return (<div className="tab-bar inset-text">
            <div className="tab-container" style={{display:"table",tableLayout: "fixed",width:"100%"}}>
                <div style={{display:"table-row"}}>
                    {this.props.labels.map((val,i) => 
                        <div
                            key = {"tab_"+i}
                            style = {{display:"table-cell", width:tabpercent+"%" , cursor:"pointer"}}
                            className = {"tab-cell" + (i==this.props.selected?" selected":"")}
                            onClick={
                                function() { 
                                    if(onTabClick) {
                                        self.handleClick(onTabClick.bind(this), i, arguments);
                                    } 
                                }
                            }
                        >{val}</div>)
                    }
                </div>
                <div style={{display:"table-row", height:"4px"}}>
                    <div style={{position:"relative",width:this.props.labels.length*100+"%",height:"inherit"}}>
                        <div style={{
                            position:"absolute",
                            width:tabpercent+"%",
                            height:"inherit",
                            transform:"translate("+this.props.selected*100+"%,0)"}} 
                            className="tab-underline" 
                            />
                    </div>
                </div>
            </div>
            
        </div>)
    }  
}

/*<div style={{display:"table-row", height:"4px", position:"relative"}}>
                    {this.props.labels.map((val,i) =>
                        <div style={{display:"table-cell"}} className={this.props.selected==i?"tab-underline":"tab-nounderline"}></div>)}
                </div>*/


// WEBPACK FOOTER //
// ./src/js/components/Tabs/Tabs.jsx